import React from "react";
var __jsx = React.createElement;
import stl from "./LabelsCA.module.css";
var LabelsCA = function LabelsCA(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.lblCAContainer, props.hasBrdr ? stl.hasBrdr : undefined, "mb-3"].join(" "),
    id: "car-labels-container"
  }, props.tags && props.tags.map(function (tag, idx) {
    return /*#__PURE__*/React.createElement("label", {
      key: "lbl" + idx,
      id: "car-label-".concat(idx),
      style: {
        backgroundColor: tag.background_color ? tag.background_color : "",
        color: tag.text_color ? tag.text_color : ""
      }
    }, tag.icon && /*#__PURE__*/React.createElement("img", {
      width: "10px",
      src: tag.icon,
      alt: "icon",
      id: "car-label-icon-".concat(idx)
    }), /*#__PURE__*/React.createElement("span", {
      id: "car-label-text-".concat(idx)
    }, tag.tag_name, " ", tag.attr && /*#__PURE__*/React.createElement("span", null, tag.attr)));
  }));
};
export default LabelsCA;